import React from 'react';
import MarketDays from '../components/MarketDays';

const Page = () => <MarketDays />;

export default Page;
